import React from "react";
import Image from "next/image";

const BridgeBanner = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -100;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };
  return (
    <>
      <div className="md:block hidden mx-auto w-full 2xl:h-[700px] md:h-[95vh] h-[95vh] xl:px-0 md:px-6 lg:!px-6  px-5 relative md:bg-bottom bg-center md:bg-[url(/home/footer_bg.png)] bg-[url(/images/ban.png)] bg-repeat bg-cover bg-[length:100% 100%] md:pb-0 pb-[0px]">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-50 h-full relative">
          <div className="flex justify-between items-center relative md:top-14">
            <div className="md:relative 2xl:w-[45%] md:w-[58%]">
              <h1 className="md:w-[120%] xl:text-[60px] lg:text-[50px] md:text-[58px] text-[24px] text-left font-bold md:leading-[42px] leading-[1.2] text-[#08213E] md:mt-[20%]">
                Miles Bridge Program
                <span className="xl:text-[48px] lg:text-[48px] md:text-[48px]">
                  *
                </span>
                <br />
              </h1>
              <p className="font-medium xl:text-[26px] lg:text-[26px] md:text-[26px] leading-[1.3] md:mt-6">
                Now appear for the CPA exam with a 3-year Bachelors Degree from
                India
              </p>
              <div className="flex">
                <div>
                  <p className="mt-8 justify-start md:w-[120%]">
                    <span className="border-[1.333px] border-[#FFA548] rounded-lg bg-[#FFFFFF] text-[18px] leading-[34px] text-[#000000] font-semibold px-[16px] py-[12px]">
                      India's only CPA-integrated online M.Com, approved for
                      pre-educational eligibility
                    </span>
                  </p>
                </div>
              </div>
              <p className="font-medium xl:text-[16px] lg:text-[16px] md:text-[17px] leading-[1.3] md:mt-8">
                *Approved by the respective State Board of Accountancy
              </p>
              <div
                className="grp_btn flex items-center cursor-pointer md:mt-10"
                onClick={() => scrollToSection("CPA Eligibility Requirements")}
              >
                <Image
                  priority
                  src="/images/accounting/arrow.png"
                  alt="arrow image"
                  className="new_arrow md:w-[40px] 2xl:w-[45px]"
                  width={45}
                  height={45}
                />
                <p className="new__discover_btn font-medium inline-block md:px-[30px] md:text-[14px] 2xl:text-base">
                  Know More
                </p>
              </div>
            </div>
          </div>
          <div className="lg_desktop">
            <Image
              src="/cpa/bridge-course/bridge-bannerDesk.webp"
              alt="bridge course"
              className="absolute top-0 bottom-0 h-full right-0 z-0"
              width={600}
              height={580}
              priority
            />
          </div>
        </div>
        <div className="md_desktop">
          <Image
            src="/cpa/bridge-course/bridge-bannerDesk.webp"
            alt="bridge course"
            className="absolute top-0 bottom-0 right-0 md:block hidden md:w-[650px] md:h-full z-20"
            width={852}
            height={568}
            priority
          />
        </div>
      </div>

      <div className="md:block hidden bg-[#071B30] w-full md:py-8 py-10 z-30">
        <div className="lg:container mx-auto">
          <div className="flex md:justify-between md:flex-nowrap flex-wrap md:px-14">
            <div className="md:w-[30%] w-[100%] text-center">
              <p className="md:text-[32px] text-3xl font-medium text-white">
                70,000+
              </p>
              <p className="md:text-[20px] text-xl font-medium text-white md:mt-3 mt-1">
                Global Alumni
              </p>
            </div>

            <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
              <p className="md:text-[32px] text-3xl font-medium text-white">
                600+
              </p>
              <p className="md:text-[20px] text-xl font-medium text-white md:mt-3 mt-1">
                Corporate Partnerships
              </p>
            </div>

            <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
              <p className="md:text-[32px] text-3xl font-medium text-white">
                100+
              </p>
              <p className="md:text-[20px] text-xl font-medium text-white md:mt-3 mt-1">
                Universities
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BridgeBanner;
